export const actionTypes = {
  ADD_VOICE: 'ADD_VOICE',
  CLEAR_VOICE: 'CLEAR_VOICE',
  OPEN_POPUP_VOICE_CLONING_OPTIONS: 'OPEN_POPUP_VOICE_CLONING_OPTIONS',
  CLOSE_POPUP_VOICE_CLONING_OPTIONS: 'CLOSE_POPUP_VOICE_CLONING_OPTIONS',
  REFRESH_VOICES_LIST: 'REFRESH_VOICES_LIST',
};

export const addVoice = (voice) => ({
  type: actionTypes.ADD_VOICE,
  voice,
});

export const clearVoice = () => ({
  type: actionTypes.CLEAR_VOICE,
});

export const openPopupVoiceCloningOptions = () => ({
  type: actionTypes.OPEN_POPUP_VOICE_CLONING_OPTIONS,
});

export const closePopupVoiceCloningOptions = () => ({
  type: actionTypes.CLOSE_POPUP_VOICE_CLONING_OPTIONS,
});

export const refreshVoicesList = (value) => ({
  type: actionTypes.REFRESH_VOICES_LIST,
  value,
});
